import { useEffect, useState } from "react";
import type { LobbyStats } from "@mk/shared";
import { getSocket } from "../../lib/socket.ts";

/**
 * Lobide kaç kişi var.
 *
 * Sunucu sayı değiştikçe yayın yapıyor; ekranı yeni açan oyuncu ilk değeri
 * `lobby:sync` ile istiyor, yoksa kimse gelip gitmediği sürece sayıyı hiç
 * göremezdi.
 *
 * Sayı gelmediyse `null` döner — o durumda ekran sayı yerine hiçbir şey
 * göstermiyor; "0 oyuncu çevrimiçi" demek yanlış olurdu.
 */
export function useLobbyStats(): LobbyStats | null {
  const [stats, setStats] = useState<LobbyStats | null>(null);

  useEffect(() => {
    const socket = getSocket();
    const onStats = (payload: LobbyStats) => setStats(payload);

    socket.on("lobby:stats", onStats);
    socket.emit("lobby:sync", (payload: LobbyStats) => {
      if (payload && typeof payload.online === "number") setStats(payload);
    });

    // Yeniden bağlanınca sayı bayatlamış olabilir.
    const onConnect = () => {
      socket.emit("lobby:sync", (payload: LobbyStats) => {
        if (payload && typeof payload.online === "number") setStats(payload);
      });
    };
    socket.on("connect", onConnect);

    return () => {
      socket.off("lobby:stats", onStats);
      socket.off("connect", onConnect);
    };
  }, []);

  return stats;
}
